import React, { useEffect } from 'react';
import { Box, CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import { WebPhoneProviderV3 } from '../../contexts/WebPhoneContextV3';
import { AuthProvider } from '../../contexts/AuthContext';
import WebPhoneStandaloneMobileV3 from './WebPhoneStandaloneMobileV3';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#0A84FF',
    },
    secondary: {
      main: '#34C759',
    },
    background: {
      default: '#000',
      paper: '#1c1c1e',
    },
  },
});

const WebPhonePopupMobileV3: React.FC = () => {
  useEffect(() => {
    document.title = 'Phone';
  }, []);

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <AuthProvider>
        <WebPhoneProviderV3>
          <Box
            sx={{
              width: '100vw',
              height: '100vh',
              overflow: 'hidden',
              bgcolor: 'background.default',
            }}
          >
            <WebPhoneStandaloneMobileV3 />
          </Box>
        </WebPhoneProviderV3>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default WebPhonePopupMobileV3;
